import type { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { TopHeader } from "./TopHeader";
import type { PortalId } from "@/domain/screen";

const THEME_CLASS: Record<PortalId, string> = {
  Investor: "theme-investor",
  Guest: "theme-guest",
  Admin: "theme-admin",
};

export function AppShell({ portal, children, userName, userRole, unreadCount }: {
  portal: PortalId;
  children: ReactNode;
  userName?: string;
  userRole?: string;
  unreadCount?: number;
}) {
  return (
    <div className={`app-shell ${THEME_CLASS[portal]}`}>
      <Sidebar portal={portal} />
      <div className="main-column">
        <TopHeader portal={portal} userName={userName} userRole={userRole} unreadCount={unreadCount} />
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
}
